import { Amplify } from 'aws-amplify'
import { getCurrentSession } from '../getCurrentSession'

export const isAuthenticated = (customContext?: typeof Amplify) =>
  getCurrentSession(customContext)
    .then(() => true)
    .catch(() => false)
